import { gql } from '@apollo/client';

export default gql`
  fragment schema on schemas {
    id
    description
    name
  }
`;
